import React from "react";
import { Link } from "react-router-dom";

export function Emblem({ size = 44, className = "" }) {
  return (
    <img
      src="/emblem.png"
      alt="Made in Boston emblem — the Stump, a Massachusetts silhouette, and a handshake across the crossing"
      width={size}
      height={size}
      className={`rounded-full ${className}`}
      style={{ width: size, height: size, objectFit: "cover" }}
    />
  );
}

export function Wordmark({ withTagline = true }) {
  return (
    <Link to="/" data-testid="brand-lockup" className="flex items-center gap-3 sm:gap-4 group">
      <Emblem size={46} className="transition-transform duration-300 group-hover:scale-105" />
      <div className="flex flex-col leading-none">
        <span className="font-serif font-bold text-lg sm:text-xl tracking-wide text-[#003366]">
          Made in Boston
        </span>
        {withTagline && (
          <span className="hidden sm:block font-sans text-[10px] uppercase tracking-[0.2em] text-[#505A68] mt-1">
            Two harbours. One name.
          </span>
        )}
      </div>
    </Link>
  );
}
